/**
 * UserStatusBadge Component
 *
 * Displays a colored badge for user status (active, inactive, suspended, invited).
 */

import React from 'react';
import { Badge } from '../../../components/ui/Badge';

export type UserStatus = 'active' | 'inactive' | 'suspended' | 'invited';

interface UserStatusBadgeProps {
  status: UserStatus;
}

export const UserStatusBadge: React.FC<UserStatusBadgeProps> = ({ status }) => {
  const variantMap: Record<UserStatus, 'success' | 'default' | 'danger' | 'warning'> = {
    active: 'success',
    inactive: 'default',
    suspended: 'danger',
    invited: 'warning',
  };

  const labels: Record<UserStatus, string> = {
    active: 'Active',
    inactive: 'Inactive',
    suspended: 'Suspended',
    invited: 'Invited',
  };

  return (
    <Badge variant={variantMap[status]}>
      {labels[status]}
    </Badge>
  );
};
